import { render, staticRenderFns } from "./loremipsum.vue?vue&type=template&id=1ace39da&scoped=true&"
import script from "./loremipsum.vue?vue&type=script&lang=js&"
export * from "./loremipsum.vue?vue&type=script&lang=js&"
import style0 from "./loremipsum.vue?vue&type=style&index=0&id=1ace39da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ace39da",
  null
  
)

export default component.exports